import * as React from 'react';

import {FieldArray} from 'redux-form';

import type {Market} from 'nutshell-core/types';

import {FormField} from 'shells/form/form-field';

import {MarketField} from './market-field';
import {ProductSelect} from './product-select';

import styles from './product-select-field.module.css';

type Props = {
    fieldKey: string;
    title: string;
    isRequired: boolean;
    validate: (...args: any) => any;
    currentMarket: Market | null | undefined;
};

export function ProductSelectField(props: Props) {
    return (
        <FormField
            key={props.fieldKey}
            innerId={props.fieldKey}
            label={props.title}
            isRequired={props.isRequired}
            // @ts-expect-error
            validate={props.validate}
        >
            <div className={styles.container}>
                {NutClientConfig.hasMultipleMarkets ? (
                    <div className={styles.market}>
                        <MarketField />
                    </div>
                ) : undefined}
                <FieldArray
                    name={props.fieldKey}
                    component={ProductSelect}
                    // @ts-expect-error
                    isRequired={props.isRequired}
                    autoFocus={false}
                    shouldAnd={true}
                    {...props}
                />
            </div>
        </FormField>
    );
}
